import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { Element, Icon } from '../../atoms';
import styles from './chile-rating.styles';
import { UIComponent } from '../..';

const StarRating: UIComponent<{
  children?: React.ReactNode;
  /**
   * Whether the StarRating is interactive or not. If true, the StarRating will be clickable and will show/hide stars on hover
   */
  isInteractive?: boolean;
  /**
   * Callback to be called when the StarRating is clicked
   */
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  /**
   * Callback to be called when the StarRating value change during a click event and isInteractive is true
   */
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  /**
   * Set maximum rating (Amount of stars)
   */
  total?: number;
  /**
   * The rating value of the StarRating (decimal values between .25 and .74 will be shown as half stars)
   */
  value?: number;
}> = forwardRef(({ className, color, isInteractive, onChange, value = 0, ...props }, ref: any) => {
  return (
    <span>
      <Element ref={ref} as="div" className={clsx(styles.root, className)} isInteractive={isInteractive} {...props}>
        <Icon name="thermometer" className={styles.thermometer} />
        <span className={styles.iconsContainer}>
          {Array.from({ length: value }, (_, i) => {
            return (
              <span key={i} className={styles.icon} data-rating={i + 1}>
                🌶️️️
              </span>
            );
          })}
        </span>
      </Element>
    </span>
  );
});

export default StarRating;
